<template>
	<section>
		<compSteplist :status="getStatus" :progressStatus="getProgressStatus" style="margin-left:220px"></compSteplist>
        <!-- 按钮展示 -->
        <div class="margin-bottom-10">
            <vButton v-if="formData.status == 10" class="margin-right-10" theme="success" @click="complateBill">处理完成</vButton>
            <vButton v-if="formData.status == 0" class="margin-right-10" theme="gray" @click="destroyPackage">销毁包裹</vButton>
            <vButton v-if="formData.status == 20" class="margin-right-10" theme="info" @click="complateDestroy">销毁完成</vButton>
            <vButton v-if="formData.errorStatus !== 99999" class="margin-right-10" theme="info" @click="rehandle">重处理</vButton>
            <vButton v-if="formData.errorStatus !== 99999" class="margin-right-10" theme="gray" @click="ignoreAbnormal">忽略异常</vButton>
            <vButton v-if="formData.status == 5" class="margin-right-10" theme="info" @click="rePush">重推仓库</vButton>
            <vButton v-if="!isActive" style="position:absolute;right:10px" theme="default" @click="cancel">返回</vButton>
        </div>
		<compWrapper title="基本信息" theme="primary">
			<compFormQuery class="margin-layout" :formdata="getBase" :value="formData" placeholder="--"></compFormQuery>
		</compWrapper>
		<compWrapper title="产品信息" theme="primary">
			<vTableSimple class="margin-layout" :data="productList" :columns="getCusproductColumns"></vTableSimple>
		</compWrapper>
        <compWrapper title="照片信息" theme="success">
			<vTableSimple class="margin-layout" :data="photoList" :columns="getPhotoColumns"></vTableSimple>
		</compWrapper>
        <compWrapper :title="$t('global.common.attache',{defaultValue:'附件信息'})" theme="info">
			<compAttach
				class="margin-layout"
				ref="attachlist"
				:data="attachList"
				:activeid="id"
                :formData="formData"
				@on-update="getDetail"
			></compAttach>
		</compWrapper>
		<compLog wrapper :data="logList"></compLog>
		<vLoading size="large" transfer :loading="loading"></vLoading>
        <compModal
			v-model="modalProps.show"
			v-bind="modalProps"
            @on-close="closemodalprops"
		>
            <component ref="cusref" :is="modalProps.component"  v-bind="modalProps" @on-close="closemodalprops" v-on="modalProps.on"></component>
        </compModal>
	</section>
</template>

<script>
import { HttpClaimPlanOrderManageDetail, HttpClaimPlanOrderReprocess, HttpClaimPlanOrderIgnoreError, HttpClaimPlanOrderRepushWareHouse, HttpClaimPlanOrderManageComplete, HttpClaimPlanOrderManageDestroy, HttpClaimPlanOrderManageDestroyComplete } from '@/service/salesreturns';
import mixin from "../mixin";
import { mapGetters } from 'vuex';
import compAttach from './attach';
import compHandleWay from './handlephoto.vue';
import compSteplist from '../steplist';
import compPhoto from '../photo.vue'

export default {
	mixins: [mixin],
    props:['activeids'],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compLog: () => import("@components/templates/log"),
		compModal: () => import("@components/templates/modal"),
        compAttach,
        compHandleWay,
        compSteplist,
        compPhoto,
	},
	data() {
		return {
			loading: false,
			id: this.$route.query.id || this.activeids,
			formData: {},
            isActive: this.activeids ? true : false,
			productList: [],
			logList: [],
            photoList:[],
			attachList: [],//附件列表
			modalProps: {
				show: false,
			},
		};
	},
	created() {
		this.getDetail();
	},
	computed: {
        ...mapGetters('dictionary', ['getSelfmanageorgList', 'getCusproductList','getUserManageWarehouseList', 'getBillcusWareList']),
		getBase() {
			return [{
				label: "认领单号",
				key: "claimPlanNo",
                render: ()=>{
                    return <div>
                        <span>{this.formData.claimPlanNo}</span>
                        <span style="margin-left:10px;color:red;">{this.findRenderLabel(this.getErrorSimpleType, this.formData.errorStatus)}</span>
                    </div>
                }
			},
            {
				label: "状态",
				key: "status",
				options: this.getOrderStatus,
                render:( h )=>{
                    const status = this.formData.status
                    const { label = '', theme} = this.getOrderStatus.find(function (item) {
                        return item.value == status
                    }) || {};
                    return <vButton ghost theme={theme} size="small" class="cursor-default">{label || '--'}</vButton>
                }
			},
            {
                label: "来源单号",
                key: "sourceNo"
            },
			{
				label: "退货仓库",
				key: "warehosueName",
			},
			{
				label: "项目",
				key: "lineName",
			},
			{
				label: "Tracking No",
				key: "trackingNo",
			},
            {   label: this.$t('fbb.alloment.client_organization',{defaultValue:'客户'}),
                key: 'organizationId',
                options: this.getSelfmanageorgList,
            },
            {
                label: "备注",
                key: "remark"
            }];
		},
		getCusproductColumns() {
            return[
                {
                    title: 'No',
                    type: 'index',
                    width: 60
                },
                {
                    title: 'SKU',
                    key: 'sku'
                },
                {
                    title: '认领数量',
                    key:'qty'
                },
                {
                    title: '处理数量',
                    key:'qtyDone'
                },
                {
                    title: '建议处理方式',
                    render:(h,{row})=>{
                        return <div>{ this.findRenderLabel(this.getHandleType, row.goodsReturnType)|| '--' }</div>
                    }
                },
                {
                    title: '备注',
                    render: (h,{row})=>{
                        return row.remark || '--'
                    }
                },
                {
                    title: "操作",
                    width: this.formData.status == 5 || this.formData.status == 10  ? 120 : 0,
                    render: (h,{row})=>{
                        if( row.qtyDone < row.qty ){
                            return h('vButton', {
                                props: {
                                    theme: 'primary',
                                },
                                nativeOn: {
                                    click: this.handlePhoto.bind(this,row)
                                }
                            }, "处理")
                        }else{
                            return '--'
                        }
                    }
                },
                {
                    title: '更新时间',
                    key:'updatedAt'
                },
            ]
		},
        getPhotoColumns(){
            return[
                {
                    title: 'No',
                    type: 'index'
                },
                {
                    title: '来源单号',
                    key: 'sourceNo'
                },
                {
                    title: 'SKU',
                    key: 'sku',
                    render: (h, { row })=>{
                        return <div>{row.sku || '--'}</div>
                    }
                },
                {
                    title: '照片',
                    render: (h, {row})=>{
                        let img = [];
                        if(row.pictureUrl){
                            // row.picturesUrl.map(item => {
                            //     img.push(
                            //         <div style="float: left; cursor: pointer; margin-right: 10px;" onClick={this.handleImgModal.bind(this, item)}>
                            //             <img style="width: 50px; height: 50px;" src={item} />
                            //         </div>
                            //     )
                            // });
                            let imgList = JSON.parse(row.pictureUrl);
                            imgList.map((item, index) => {
                                let newUrl = item + '?image_process=image/resize,w_100&x-oss-process=image/resize,w_100'
                                img.push(
                                    <div style="float: left; cursor: pointer; margin-right: 10px;" onClick={this.handleImgModal.bind(this, {url: index, urlList: imgList})}>
                                        <img style="width: 50px; height: 50px;" src={newUrl} />
                                    </div>
                                )
                            });
                        }
                        else{
                            img = '--'
                        }
                        return (
                            <div style="padding: 10px 0; overflow: hidden;">
                                {img}
                            </div>
                        );
                    }
                },
                {
                    title: '备注',
                    key:'remark',
                    render: (h, { row })=>{
                        return <div>{row.remark || '--'}</div>
                    }
                },
                {
                    title: '创建时间',
                    key:'updatedAt'
                },
            ]
        },
        getStatus() {
			return this.type !== 'add' && this.formData.status
		},
        getProgressStatus() {
            const arr = [
                {
                    name: this.$tc('fbb.sales.sales_status', 1, { defaultValue: '待认领' }),
                    value: '0',
                },
                {
                    name: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '待处理' }),
                    value: '5',
                },
                {
                    name: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '处理中' }),
                    value: '10',
                },
                {
                    name: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '已处理' }),
                    value: '15',
                }]
			return arr
        }
    },
	methods: {
        closemodalprops(){
            this.modalProps = {};
            this.$emit('on-openCloseable');
        },
        handleImgModal (obj) {
            this.$emit('on-closeCloseable');
            this.modalProps = {
                show: true,
                title: this.$t('global.photo.info', { defaultValue: '照片信息' }),
                component: "compPhoto",
                currentUrl: obj.url,
                urlList: obj.urlList,
                showFooter: false,
                width: 1200,
                // url: url,
            }
        },
		//获取计划单详情
		getDetail() {
			this.loading = true;
			HttpClaimPlanOrderManageDetail({ id: this.id }).then(res => {
				const data = res.data || {};
				this.formData = data.claimPlanOrderEntity;
				this.productList = data.claimPlanOrderItemEntities;
				this.logList = data.opLogEntityList;
                this.photoList = data.claimPlanOrderPictureEntities;
                this.attachList = data.orderAttachesEntities;
				this.loading = false;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(this.$t(err.langCode, { defaultValue: err.message }));
			})
		},
        // 产品信息处理
        handlePhoto(obj){
            this.modalProps = {
				show: true,
				title: "认领处理",
				component: "compHandleWay",
                showFooter:false,
				alert: "primary",
				width: 600,
				showDesc: false,
				params: { obj, headId: this.id,},
                on: {
					"on-success": () => {
						this.modalProps = {};
                        this.getDetail()
					},
				}
			}
        },
		// 处理完成
		complateBill() {
			this.modalProps = {
				show: true,
				title: "处理完成",
				alert: "success",
				width: "middle",
				showDesc: false,
				params: { id: this.id },
				ajaxRequest: HttpClaimPlanOrderManageComplete,
				formdata: [
					{
						tag: "vTextarea",
						key: "remark",
						labelWidth: 'auto',
						span: 24,
						label: "备注",
                        required: false,
					}
				],
			}
		},
        // 销毁包裹
        destroyPackage(){
            this.modalProps = {
				show: true,
				title: "销毁包裹",
				alert: "success",
				width: "middle",
				desc: '操作后单据状态将变为“待销毁”。',
				params: { id: this.id },
				ajaxRequest: HttpClaimPlanOrderManageDestroy,
				formdata: [
					{
						tag: "vTextarea",
						key: "remark",
						labelWidth: 'auto',
						span: 24,
						label: "备注",
                        required: false,
					}
				],
			}
        },
        // 销毁完成
        complateDestroy(){
            this.modalProps = {
				show: true,
				title: "销毁完成",
				alert: "success",
				width: "middle",
				showDesc: false,
				params: { id: this.id },
				ajaxRequest: HttpClaimPlanOrderManageDestroyComplete,
				formdata: [
					{
						tag: "vTextarea",
						key: "remark",
						labelWidth: 'auto',
						span: 24,
						label: "备注",
                        required: false,
					}
				],
			}
        },
        // 重处理
        rehandle(){
            this.modalProps = {
				show: true,
				title: "重处理",
				alert: "error",
				showDesc: true,
				params: { id: this.id },
				ajaxRequest: HttpClaimPlanOrderReprocess,
			}
        },
        // 忽略异常
        ignoreAbnormal(){
            this.modalProps = {
				show: true,
				title: "忽略异常",
				alert: "error",
				showDesc: true,
				params: { id: this.id },
				ajaxRequest: HttpClaimPlanOrderIgnoreError,
			}
        },
        // 重推仓库
        rePush(){
            this.modalProps = {
				show: true,
				title: "重推仓库",
				alert: "error",
				showDesc: true,
				params: { id: this.id },
				ajaxRequest: HttpClaimPlanOrderRepushWareHouse,
			}
        },
		cancel() {
			this.$router.push({
				name: 'claimOrderManage'
			})
		}
	}
};
</script>
